module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_5010.3f271432.png";